import { createSlice } from '@reduxjs/toolkit';
import { IQuizItemsState } from '../../types/quiz';

const initialState: IQuizItemsState = {
  types: [],
  items: {} as unknown as IQuizItemsState['items'],
};

export const quizItemsSlice = createSlice({
  name: 'quizItems',
  initialState,
  reducers: {},
});

export const { reducer: quizItemsReducer } = quizItemsSlice;
